<template>
  <div class="pie-wrapper">
    <span class="label"><slot></slot></span>
    <div class="pie" v-bind:style="pie">
      <div v-bind:class="['half-circle']" v-bind:style="leftSide"></div>
      <div v-bind:class="['half-circle']" v-bind:style="rightSide"></div>
    </div>
    <div class="shadow"></div>
  </div>
</template>

<script>
  export default {
    name: 'RadialProgressBar',
    props: {
      progress: {
        type: Number,
        default: 0
      },

    },
    computed: {
      leftSide: function () {
        return {'transform': `rotate(${this.progress * 3.6}deg)`};
      },
      rightSide: function () {
        if (this.progress <= 50) {
          return {'display': 'none'};
        }
        return {'transform': 'rotate(180deg)'};
      },
      pie: function () {
        if (this.progress <= 50) {
          return {};
        }
        return {
          'clip': 'rect(auto, auto, auto, auto)'
        }
      }
    }
  }
</script>


<style scoped lang="scss">
  $default-size: 3.2rem;
  $border-default-size: 0.4rem;
  $border-default-color-active: #CF0920;
  $border-default-color: #EAECF2;
  $text-color: #0B1022;

  // -- mixins
  @mixin size($width, $height) {
    height: $height;
    width: $width;
  }

  @mixin draw-progress($progress, $color) {
    .pie {
      .half-circle {
        border-color: $color;
      }

      .left-side {
        transform: rotate($progress * 3.6deg);
      }

      @if $progress <= 50 {
        .right-side {
          display: none;
        }
      } @else {
        clip: rect(auto, auto, auto, auto);

        .right-side {
          transform: rotate(180deg);
        }
      }
    }
  }

  .pie-wrapper {
    @include size($default-size, $default-size);
    float: left;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &:nth-child(3n + 1) {
      clear: both;
    }

    .pie {
      @include size(100%, 100%);
      clip: rect(0, $default-size, $default-size, $default-size / 2);
      left: 0;
      position: absolute;
      top: 0;

      .half-circle {
        @include size(100%, 100%);
        border: $border-default-size solid $border-default-color-active;
        border-radius: 50%;
        clip: rect(0, $default-size / 2, $default-size, 0);
        left: 0;
        position: absolute;
        top: 0;
      }
    }

    .label {
      border-radius: 50%;
      position: absolute;
      text-align: center;

      font-family: FuturaPT;
      font-size: 1.6rem;
      line-height: 1.2;
      letter-spacing: 0.1rem;
      color: $text-color;

      background: none;
    }

    .shadow {
      @include size(100%, 100%);
      border: $border-default-size solid $border-default-color;
      border-radius: 50%;
    }

    &.progress-95 {
      @include draw-progress(12, #CF0920);
    }
  }

</style>
